import CloseIcon from "@mui/icons-material/Close"
import IconButton from "@mui/material/IconButton"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import React, { useContext } from "react"

import LangContext from "../../contexts/LangContext"
import "../../styles/search.scss"
import "../../styles/enhanced-search.scss"
import EnhancedSearchResults from "./EnhancedSearchResults"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 999999,
  "& .MuiDialog-paper": {
    maxWidth: "100%",
    width: "100%",
    maxHeight: "100%",
    margin: theme.spacing(0),
    borderRadius: theme.shape.borderRadius * 0,
    height: "100%",

  },
  "& .MuiDialogContent-root": {
    padding: 0,
    overflow: "hidden",
  },
}))

const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  position: "sticky",
  top: 0,
  zIndex: 10,
}))

const ContentBox = styled(Box)({
  height: "100%",
  overflow: "hidden",
})

const EnhancedSearchDialog = ({ open, onClose }) => {
  const lang = useContext(LangContext)
  
  const data = useStaticQuery(graphql`
    query EnhancedSearchIndexQuery {
      siteSearchIndex {
        index
      }
    }
  `)

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="search-dialog-title"
      fullWidth
      maxWidth="md"
    >
      <HeaderBox>
        <Typography variant="h6" component="h2" id="search-dialog-title">
          Căutare avansată
        </Typography>
        <IconButton
          color="inherit"
          onClick={onClose}
          edge="end"
          aria-label="închide căutarea"
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </HeaderBox>
      
      <DialogContent>
        <ContentBox>
          <EnhancedSearchResults
            searchIndex={data.siteSearchIndex.index}
            lang={lang}
            onResultClick={onClose}
          />
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  )
}

export default EnhancedSearchDialog

EnhancedSearchDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}